const ACTIONS = {
    LOGIN: 'LOGIN',
    GET_TOKEN: 'GET_TOKEN',
    GET_USER: 'GET_USER',
    VIEW_MENU: 'VIEW_MENU',
    HIDE_MENU: 'HIDE_MENU'
}

export default ACTIONS